import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';
import Login from './pages/LogIn/LoginPage';
import Register from './pages/Register/RegisterPage';
import Dashboard from './components/Dashboard';
import LandingPage from './pages/LandingPage/LandingPage';
import DoctorReview from './pages/DoctorReview/DoctorReview';
import AdminHealth from './pages/AdminHealth/AdminHealth';
import ProfilePage from './pages/Profile/ProfilePage';
import EvaluationResults from './pages/EvaluationResults/EvaluationResults';
import LegalPage from './pages/Legal/LegalPage';
import SubscriptionPage from './pages/Subscription/SubscriptionPage';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import LanguageSwitcher from './components/LanguageSwitcher/LanguageSwitcher';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';

function App() {
  return (
    <ThemeProvider>
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="utility-bar">
            <LanguageSwitcher />
            <ThemeToggle />
          </div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/legal/terms" element={<LegalPage documentType="terms" />} />
          <Route path="/legal/privacy" element={<LegalPage documentType="privacy" />} />
          <Route path="/legal/cookies" element={<LegalPage documentType="cookies" />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/results/:submissionId" element={<RoleRoute role="student"><EvaluationResults /></RoleRoute>} />
          <Route path="/doctor-review" element={<RoleRoute role="doctor"><DoctorReview /></RoleRoute>} />
          <Route
            path="/admin/health"
            element={
              <RoleRoute role="doctor">
                <AdminHealth />
              </RoleRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
